import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-serviceareas-edit-modal',
  templateUrl: './serviceareas-edit-modal.component.html',
  styleUrls: ['./serviceareas-edit-modal.component.css']
})
export class ServiceareasEditModalComponent implements OnInit {
  @Input() serviceAreas: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveServiceAreas(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}